// This file is generated by scripts/generate-phosphor-icons.js.
// Run yarn generate:icons from the shared directory when the Phosphor selection changes.

export const phosphorIconList: { icon: string; label: string }[] = [
  { icon: "acorn", label: "Acorn" },
  { icon: "address-book", label: "Address book" },
  { icon: "address-book-tabs", label: "Address book tabs" },
  { icon: "air-traffic-control", label: "Air traffic control" },
  { icon: "airplane", label: "Airplane" },
  { icon: "airplane-in-flight", label: "Airplane in flight" },
  { icon: "airplane-landing", label: "Airplane landing" },
  { icon: "airplane-takeoff", label: "Airplane takeoff" },
  { icon: "airplane-taxiing", label: "Airplane taxiing" },
  { icon: "airplane-tilt", label: "Airplane tilt" },
  { icon: "airplay", label: "Airplay" },
  { icon: "alarm", label: "Alarm" },
  { icon: "alien", label: "Alien" },
  { icon: "align-bottom", label: "Align bottom" },
  { icon: "align-bottom-simple", label: "Align bottom simple" },
  { icon: "align-center-horizontal", label: "Align center horizontal" },
  { icon: "align-center-horizontal-simple", label: "Align center horizontal simple" },
  { icon: "align-center-vertical", label: "Align center vertical" },
  { icon: "align-center-vertical-simple", label: "Align center vertical simple" },
  { icon: "align-left", label: "Align left" },
  { icon: "align-left-simple", label: "Align left simple" },
  { icon: "align-right", label: "Align right" },
  { icon: "align-right-simple", label: "Align right simple" },
  { icon: "align-top", label: "Align top" },
  { icon: "align-top-simple", label: "Align top simple" },
  { icon: "amazon-logo", label: "Amazon logo" },
  { icon: "ambulance", label: "Ambulance" },
  { icon: "anchor", label: "Anchor" },
  { icon: "anchor-simple", label: "Anchor simple" },
  { icon: "android-logo", label: "Android logo" },
  { icon: "angle", label: "Angle" },
  { icon: "angular-logo", label: "Angular logo" },
  { icon: "aperture", label: "Aperture" },
  { icon: "app-store-logo", label: "App store logo" },
  { icon: "app-window", label: "App window" },
  { icon: "apple-logo", label: "Apple logo" },
  { icon: "apple-podcasts-logo", label: "Apple podcasts logo" },
  { icon: "approximate-equals", label: "Approximate equals" },
  { icon: "archive", label: "Archive" },
  { icon: "armchair", label: "Armchair" },
  { icon: "arrow-arc-left", label: "Arrow arc left" },
  { icon: "arrow-arc-right", label: "Arrow arc right" },
  { icon: "arrow-bend-double-up-left", label: "Arrow bend double up left" },
  { icon: "arrow-bend-double-up-right", label: "Arrow bend double up right" },
  { icon: "arrow-bend-down-left", label: "Arrow bend down left" },
  { icon: "arrow-bend-down-right", label: "Arrow bend down right" },
  { icon: "arrow-bend-left-down", label: "Arrow bend left down" },
  { icon: "arrow-bend-left-up", label: "Arrow bend left up" },
  { icon: "arrow-bend-right-down", label: "Arrow bend right down" },
  { icon: "arrow-bend-right-up", label: "Arrow bend right up" },
  { icon: "arrow-bend-up-left", label: "Arrow bend up left" },
  { icon: "arrow-bend-up-right", label: "Arrow bend up right" },
  { icon: "arrow-circle-down", label: "Arrow circle down" },
  { icon: "arrow-circle-down-left", label: "Arrow circle down left" },
  { icon: "arrow-circle-down-right", label: "Arrow circle down right" },
  { icon: "arrow-circle-left", label: "Arrow circle left" },
  { icon: "arrow-circle-right", label: "Arrow circle right" },
  { icon: "arrow-circle-up", label: "Arrow circle up" },
  { icon: "arrow-circle-up-left", label: "Arrow circle up left" },
  { icon: "arrow-circle-up-right", label: "Arrow circle up right" },
  { icon: "arrow-clockwise", label: "Arrow clockwise" },
  { icon: "arrow-counter-clockwise", label: "Arrow counter clockwise" },
  { icon: "arrow-down", label: "Arrow down" },
  { icon: "arrow-down-left", label: "Arrow down left" },
  { icon: "arrow-down-right", label: "Arrow down right" },
  { icon: "arrow-elbow-down-left", label: "Arrow elbow down left" },
  { icon: "arrow-elbow-down-right", label: "Arrow elbow down right" },
  { icon: "arrow-elbow-left", label: "Arrow elbow left" },
  { icon: "arrow-elbow-left-down", label: "Arrow elbow left down" },
  { icon: "arrow-elbow-left-up", label: "Arrow elbow left up" },
  { icon: "arrow-elbow-right", label: "Arrow elbow right" },
  { icon: "arrow-elbow-right-down", label: "Arrow elbow right down" },
  { icon: "arrow-elbow-right-up", label: "Arrow elbow right up" },
  { icon: "arrow-elbow-up-left", label: "Arrow elbow up left" },
  { icon: "arrow-elbow-up-right", label: "Arrow elbow up right" },
  { icon: "arrow-fat-down", label: "Arrow fat down" },
  { icon: "arrow-fat-left", label: "Arrow fat left" },
  { icon: "arrow-fat-line-down", label: "Arrow fat line down" },
  { icon: "arrow-fat-line-left", label: "Arrow fat line left" },
  { icon: "arrow-fat-line-right", label: "Arrow fat line right" },
  { icon: "arrow-fat-line-up", label: "Arrow fat line up" },
  { icon: "arrow-fat-lines-down", label: "Arrow fat lines down" },
  { icon: "arrow-fat-lines-left", label: "Arrow fat lines left" },
  { icon: "arrow-fat-lines-right", label: "Arrow fat lines right" },
  { icon: "arrow-fat-lines-up", label: "Arrow fat lines up" },
  { icon: "arrow-fat-right", label: "Arrow fat right" },
  { icon: "arrow-fat-up", label: "Arrow fat up" },
  { icon: "arrow-left", label: "Arrow left" },
  { icon: "arrow-line-down", label: "Arrow line down" },
  { icon: "arrow-line-down-left", label: "Arrow line down left" },
  { icon: "arrow-line-down-right", label: "Arrow line down right" },
  { icon: "arrow-line-left", label: "Arrow line left" },
  { icon: "arrow-line-right", label: "Arrow line right" },
  { icon: "arrow-line-up", label: "Arrow line up" },
  { icon: "arrow-line-up-left", label: "Arrow line up left" },
  { icon: "arrow-line-up-right", label: "Arrow line up right" },
  { icon: "arrow-right", label: "Arrow right" },
  { icon: "arrow-square-down", label: "Arrow square down" },
  { icon: "arrow-square-down-left", label: "Arrow square down left" },
  { icon: "arrow-square-down-right", label: "Arrow square down right" },
  { icon: "arrow-square-in", label: "Arrow square in" },
  { icon: "arrow-square-left", label: "Arrow square left" },
  { icon: "arrow-square-out", label: "Arrow square out" },
  { icon: "arrow-square-right", label: "Arrow square right" },
  { icon: "arrow-square-up", label: "Arrow square up" },
  { icon: "arrow-square-up-left", label: "Arrow square up left" },
  { icon: "arrow-square-up-right", label: "Arrow square up right" },
  { icon: "arrow-u-down-left", label: "Arrow u down left" },
  { icon: "arrow-u-down-right", label: "Arrow u down right" },
  { icon: "arrow-u-left-down", label: "Arrow u left down" },
  { icon: "arrow-u-left-up", label: "Arrow u left up" },
  { icon: "arrow-u-right-down", label: "Arrow u right down" },
  { icon: "arrow-u-right-up", label: "Arrow u right up" },
  { icon: "arrow-u-up-left", label: "Arrow u up left" },
  { icon: "arrow-u-up-right", label: "Arrow u up right" },
  { icon: "arrow-up", label: "Arrow up" },
  { icon: "arrow-up-left", label: "Arrow up left" },
  { icon: "arrow-up-right", label: "Arrow up right" },
  { icon: "arrows-clockwise", label: "Arrows clockwise" },
  { icon: "arrows-counter-clockwise", label: "Arrows counter clockwise" },
  { icon: "arrows-down-up", label: "Arrows down up" },
  { icon: "arrows-horizontal", label: "Arrows horizontal" },
  { icon: "arrows-in", label: "Arrows in" },
  { icon: "arrows-in-cardinal", label: "Arrows in cardinal" },
  { icon: "arrows-in-line-horizontal", label: "Arrows in line horizontal" },
  { icon: "arrows-in-line-vertical", label: "Arrows in line vertical" },
  { icon: "arrows-in-simple", label: "Arrows in simple" },
  { icon: "arrows-left-right", label: "Arrows left right" },
  { icon: "arrows-merge", label: "Arrows merge" },
  { icon: "arrows-out", label: "Arrows out" },
  { icon: "arrows-out-cardinal", label: "Arrows out cardinal" },
  { icon: "arrows-out-line-horizontal", label: "Arrows out line horizontal" },
  { icon: "arrows-out-line-vertical", label: "Arrows out line vertical" },
  { icon: "arrows-out-simple", label: "Arrows out simple" },
  { icon: "arrows-split", label: "Arrows split" },
  { icon: "arrows-vertical", label: "Arrows vertical" },
  { icon: "article", label: "Article" },
  { icon: "article-medium", label: "Article medium" },
  { icon: "article-ny-times", label: "Article ny times" },
  { icon: "asclepius, caduceus", label: "Asclepius, caduceus" },
  { icon: "asterisk", label: "Asterisk" },
  { icon: "asterisk-simple", label: "Asterisk simple" },
  { icon: "at", label: "At" },
  { icon: "atom", label: "Atom" },
  { icon: "avocado", label: "Avocado" },
  { icon: "axe", label: "Axe" },
  { icon: "baby", label: "Baby" },
  { icon: "baby-carriage", label: "Baby carriage" },
  { icon: "backpack", label: "Backpack" },
  { icon: "backspace", label: "Backspace" },
  { icon: "bag", label: "Bag" },
  { icon: "bag-simple", label: "Bag simple" },
  { icon: "balloon", label: "Balloon" },
  { icon: "bandaids", label: "Bandaids" },
  { icon: "bank", label: "Bank" },
  { icon: "barbell", label: "Barbell" },
  { icon: "barcode", label: "Barcode" },
  { icon: "barn", label: "Barn" },
  { icon: "barricade", label: "Barricade" },
  { icon: "baseball", label: "Baseball" },
  { icon: "baseball-cap", label: "Baseball cap" },
  { icon: "baseball-helmet", label: "Baseball helmet" },
  { icon: "basket", label: "Basket" },
  { icon: "basketball", label: "Basketball" },
  { icon: "bathtub", label: "Bathtub" },
  { icon: "battery-charging", label: "Battery charging" },
  { icon: "battery-charging-vertical", label: "Battery charging vertical" },
  { icon: "battery-empty", label: "Battery empty" },
  { icon: "battery-full", label: "Battery full" },
  { icon: "battery-high", label: "Battery high" },
  { icon: "battery-low", label: "Battery low" },
  { icon: "battery-medium", label: "Battery medium" },
  { icon: "battery-plus", label: "Battery plus" },
  { icon: "battery-plus-vertical", label: "Battery plus vertical" },
  { icon: "battery-vertical-empty", label: "Battery vertical empty" },
  { icon: "battery-vertical-full", label: "Battery vertical full" },
  { icon: "battery-vertical-high", label: "Battery vertical high" },
  { icon: "battery-vertical-low", label: "Battery vertical low" },
  { icon: "battery-vertical-medium", label: "Battery vertical medium" },
  { icon: "battery-warning", label: "Battery warning" },
  { icon: "battery-warning-vertical", label: "Battery warning vertical" },
  { icon: "beach-ball", label: "Beach ball" },
  { icon: "beanie", label: "Beanie" },
  { icon: "bed", label: "Bed" },
  { icon: "beer-bottle", label: "Beer bottle" },
  { icon: "beer-stein", label: "Beer stein" },
  { icon: "behance-logo", label: "Behance logo" },
  { icon: "bell", label: "Bell" },
  { icon: "bell-ringing", label: "Bell ringing" },
  { icon: "bell-simple", label: "Bell simple" },
  { icon: "bell-simple-ringing", label: "Bell simple ringing" },
  { icon: "bell-simple-slash", label: "Bell simple slash" },
  { icon: "bell-simple-z", label: "Bell simple z" },
  { icon: "bell-slash", label: "Bell slash" },
  { icon: "bell-z", label: "Bell z" },
  { icon: "belt", label: "Belt" },
  { icon: "bezier-curve", label: "Bezier curve" },
  { icon: "bicycle", label: "Bicycle" },
  { icon: "binary", label: "Binary" },
  { icon: "binoculars", label: "Binoculars" },
  { icon: "biohazard", label: "Biohazard" },
  { icon: "bird", label: "Bird" },
  { icon: "blueprint", label: "Blueprint" },
  { icon: "bluetooth", label: "Bluetooth" },
  { icon: "bluetooth-connected", label: "Bluetooth connected" },
  { icon: "bluetooth-slash", label: "Bluetooth slash" },
  { icon: "bluetooth-x", label: "Bluetooth x" },
  { icon: "boat", label: "Boat" },
  { icon: "bomb", label: "Bomb" },
  { icon: "bone", label: "Bone" },
  { icon: "book", label: "Book" },
  { icon: "book-bookmark", label: "Book bookmark" },
  { icon: "book-open", label: "Book open" },
  { icon: "book-open-text", label: "Book open text" },
  { icon: "book-open-user", label: "Book open user" },
  { icon: "bookmark", label: "Bookmark" },
  { icon: "bookmark-simple", label: "Bookmark simple" },
  { icon: "bookmarks", label: "Bookmarks" },
  { icon: "bookmarks-simple", label: "Bookmarks simple" },
  { icon: "books", label: "Books" },
  { icon: "boot", label: "Boot" },
  { icon: "boules", label: "Boules" },
  { icon: "bounding-box", label: "Bounding box" },
  { icon: "bowl-food", label: "Bowl food" },
  { icon: "bowl-steam", label: "Bowl steam" },
  { icon: "bowling-ball", label: "Bowling ball" },
  { icon: "box-arrow-down, archive-box", label: "Box arrow down, archive box" },
  { icon: "box-arrow-up", label: "Box arrow up" },
  { icon: "boxing-glove", label: "Boxing glove" },
  { icon: "brackets-angle", label: "Brackets angle" },
  { icon: "brackets-curly", label: "Brackets curly" },
  { icon: "brackets-round", label: "Brackets round" },
  { icon: "brackets-square", label: "Brackets square" },
  { icon: "brain", label: "Brain" },
  { icon: "brandy", label: "Brandy" },
  { icon: "bread", label: "Bread" },
  { icon: "bridge", label: "Bridge" },
  { icon: "briefcase", label: "Briefcase" },
  { icon: "briefcase-metal", label: "Briefcase metal" },
  { icon: "broadcast", label: "Broadcast" },
  { icon: "broom", label: "Broom" },
  { icon: "browser", label: "Browser" },
  { icon: "browsers", label: "Browsers" },
  { icon: "bug", label: "Bug" },
  { icon: "bug-beetle", label: "Bug beetle" },
  { icon: "bug-droid", label: "Bug droid" },
  { icon: "building", label: "Building" },
  { icon: "building-apartment", label: "Building apartment" },
  { icon: "building-office", label: "Building office" },
  { icon: "buildings", label: "Buildings" },
  { icon: "bulldozer", label: "Bulldozer" },
  { icon: "bus", label: "Bus" },
  { icon: "butterfly", label: "Butterfly" },
  { icon: "cable-car", label: "Cable car" },
  { icon: "cactus", label: "Cactus" },
  { icon: "cake", label: "Cake" },
  { icon: "calculator", label: "Calculator" },
  { icon: "calendar", label: "Calendar" },
  { icon: "calendar-blank", label: "Calendar blank" },
  { icon: "calendar-check", label: "Calendar check" },
  { icon: "calendar-dot", label: "Calendar dot" },
  { icon: "calendar-dots", label: "Calendar dots" },
  { icon: "calendar-heart", label: "Calendar heart" },
  { icon: "calendar-minus", label: "Calendar minus" },
  { icon: "calendar-plus", label: "Calendar plus" },
  { icon: "calendar-slash", label: "Calendar slash" },
  { icon: "calendar-star", label: "Calendar star" },
  { icon: "calendar-x", label: "Calendar x" },
  { icon: "call-bell", label: "Call bell" },
  { icon: "camera", label: "Camera" },
  { icon: "camera-plus", label: "Camera plus" },
  { icon: "camera-rotate", label: "Camera rotate" },
  { icon: "camera-slash", label: "Camera slash" },
  { icon: "campfire", label: "Campfire" },
  { icon: "car", label: "Car" },
  { icon: "car-battery", label: "Car battery" },
  { icon: "car-profile", label: "Car profile" },
  { icon: "car-simple", label: "Car simple" },
  { icon: "cardholder", label: "Cardholder" },
  { icon: "cards", label: "Cards" },
  { icon: "cards-three", label: "Cards three" },
  { icon: "caret-circle-double-down", label: "Caret circle double down" },
  { icon: "caret-circle-double-left", label: "Caret circle double left" },
  { icon: "caret-circle-double-right", label: "Caret circle double right" },
  { icon: "caret-circle-double-up", label: "Caret circle double up" },
  { icon: "caret-circle-down", label: "Caret circle down" },
  { icon: "caret-circle-left", label: "Caret circle left" },
  { icon: "caret-circle-right", label: "Caret circle right" },
  { icon: "caret-circle-up", label: "Caret circle up" },
  { icon: "caret-circle-up-down", label: "Caret circle up down" },
  { icon: "caret-double-down", label: "Caret double down" },
  { icon: "caret-double-left", label: "Caret double left" },
  { icon: "caret-double-right", label: "Caret double right" },
  { icon: "caret-double-up", label: "Caret double up" },
  { icon: "caret-down", label: "Caret down" },
  { icon: "caret-left", label: "Caret left" },
  { icon: "caret-line-down", label: "Caret line down" },
  { icon: "caret-line-left", label: "Caret line left" },
  { icon: "caret-line-right", label: "Caret line right" },
  { icon: "caret-line-up", label: "Caret line up" },
  { icon: "caret-right", label: "Caret right" },
  { icon: "caret-up", label: "Caret up" },
  { icon: "caret-up-down", label: "Caret up down" },
  { icon: "carrot", label: "Carrot" },
  { icon: "cash-register", label: "Cash register" },
  { icon: "cassette-tape", label: "Cassette tape" },
  { icon: "castle-turret", label: "Castle turret" },
  { icon: "cat", label: "Cat" },
  { icon: "cell-signal-full", label: "Cell signal full" },
  { icon: "cell-signal-high", label: "Cell signal high" },
  { icon: "cell-signal-low", label: "Cell signal low" },
  { icon: "cell-signal-medium", label: "Cell signal medium" },
  { icon: "cell-signal-none", label: "Cell signal none" },
  { icon: "cell-signal-slash", label: "Cell signal slash" },
  { icon: "cell-signal-x", label: "Cell signal x" },
  { icon: "cell-tower", label: "Cell tower" },
  { icon: "certificate", label: "Certificate" },
  { icon: "chair", label: "Chair" },
  { icon: "chalkboard", label: "Chalkboard" },
  { icon: "chalkboard-simple", label: "Chalkboard simple" },
  { icon: "chalkboard-teacher", label: "Chalkboard teacher" },
  { icon: "champagne", label: "Champagne" },
  { icon: "charging-station", label: "Charging station" },
  { icon: "chart-bar", label: "Chart bar" },
  { icon: "chart-bar-horizontal", label: "Chart bar horizontal" },
  { icon: "chart-donut", label: "Chart donut" },
  { icon: "chart-line", label: "Chart line" },
  { icon: "chart-line-down", label: "Chart line down" },
  { icon: "chart-line-up", label: "Chart line up" },
  { icon: "chart-pie", label: "Chart pie" },
  { icon: "chart-pie-slice", label: "Chart pie slice" },
  { icon: "chart-polar", label: "Chart polar" },
  { icon: "chart-scatter", label: "Chart scatter" },
  { icon: "chat", label: "Chat" },
  { icon: "chat-centered", label: "Chat centered" },
  { icon: "chat-centered-dots", label: "Chat centered dots" },
  { icon: "chat-centered-slash", label: "Chat centered slash" },
  { icon: "chat-centered-text", label: "Chat centered text" },
  { icon: "chat-circle", label: "Chat circle" },
  { icon: "chat-circle-dots", label: "Chat circle dots" },
  { icon: "chat-circle-slash", label: "Chat circle slash" },
  { icon: "chat-circle-text", label: "Chat circle text" },
  { icon: "chat-dots", label: "Chat dots" },
  { icon: "chat-slash", label: "Chat slash" },
  { icon: "chat-teardrop", label: "Chat teardrop" },
  { icon: "chat-teardrop-dots", label: "Chat teardrop dots" },
  { icon: "chat-teardrop-slash", label: "Chat teardrop slash" },
  { icon: "chat-teardrop-text", label: "Chat teardrop text" },
  { icon: "chat-text", label: "Chat text" },
  { icon: "chats", label: "Chats" },
  { icon: "chats-circle", label: "Chats circle" },
  { icon: "chats-teardrop", label: "Chats teardrop" },
  { icon: "check", label: "Check" },
  { icon: "check-circle", label: "Check circle" },
  { icon: "check-fat", label: "Check fat" },
  { icon: "check-square", label: "Check square" },
  { icon: "check-square-offset", label: "Check square offset" },
  { icon: "checkerboard", label: "Checkerboard" },
  { icon: "checks", label: "Checks" },
  { icon: "cheers", label: "Cheers" },
  { icon: "cheese", label: "Cheese" },
  { icon: "chef-hat", label: "Chef hat" },
  { icon: "cherries", label: "Cherries" },
  { icon: "church", label: "Church" },
  { icon: "cigarette", label: "Cigarette" },
  { icon: "cigarette-slash", label: "Cigarette slash" },
  { icon: "circle", label: "Circle" },
  { icon: "circle-dashed", label: "Circle dashed" },
  { icon: "circle-half", label: "Circle half" },
  { icon: "circle-half-tilt", label: "Circle half tilt" },
  { icon: "circle-notch", label: "Circle notch" },
  { icon: "circles-four", label: "Circles four" },
  { icon: "circles-three", label: "Circles three" },
  { icon: "circles-three-plus", label: "Circles three plus" },
  { icon: "circuitry", label: "Circuitry" },
  { icon: "city", label: "City" },
  { icon: "clipboard", label: "Clipboard" },
  { icon: "clipboard-text", label: "Clipboard text" },
  { icon: "clock", label: "Clock" },
  { icon: "clock-afternoon", label: "Clock afternoon" },
  { icon: "clock-clockwise", label: "Clock clockwise" },
  { icon: "clock-countdown", label: "Clock countdown" },
  { icon: "clock-counter-clockwise", label: "Clock counter clockwise" },
  { icon: "clock-user", label: "Clock user" },
  { icon: "closed-captioning", label: "Closed captioning" },
  { icon: "cloud", label: "Cloud" },
  { icon: "cloud-arrow-down", label: "Cloud arrow down" },
  { icon: "cloud-arrow-up", label: "Cloud arrow up" },
  { icon: "cloud-check", label: "Cloud check" },
  { icon: "cloud-fog", label: "Cloud fog" },
  { icon: "cloud-lightning", label: "Cloud lightning" },
  { icon: "cloud-moon", label: "Cloud moon" },
  { icon: "cloud-rain", label: "Cloud rain" },
  { icon: "cloud-slash", label: "Cloud slash" },
  { icon: "cloud-snow", label: "Cloud snow" },
  { icon: "cloud-sun", label: "Cloud sun" },
  { icon: "cloud-warning", label: "Cloud warning" },
  { icon: "cloud-x", label: "Cloud x" },
  { icon: "clover", label: "Clover" },
  { icon: "club", label: "Club" },
  { icon: "coat-hanger", label: "Coat hanger" },
  { icon: "coda-logo", label: "Coda logo" },
  { icon: "code", label: "Code" },
  { icon: "code-block", label: "Code block" },
  { icon: "code-simple", label: "Code simple" },
  { icon: "codepen-logo", label: "Codepen logo" },
  { icon: "codesandbox-logo", label: "Codesandbox logo" },
  { icon: "coffee", label: "Coffee" },
  { icon: "coffee-bean", label: "Coffee bean" },
  { icon: "coin", label: "Coin" },
  { icon: "coin-vertical", label: "Coin vertical" },
  { icon: "coins", label: "Coins" },
  { icon: "columns", label: "Columns" },
  { icon: "columns-plus-left", label: "Columns plus left" },
  { icon: "columns-plus-right", label: "Columns plus right" },
  { icon: "command", label: "Command" },
  { icon: "compass", label: "Compass" },
  { icon: "compass-rose", label: "Compass rose" },
  { icon: "compass-tool", label: "Compass tool" },
  { icon: "computer-tower", label: "Computer tower" },
  { icon: "confetti", label: "Confetti" },
  { icon: "contactless-payment", label: "Contactless payment" },
  { icon: "control", label: "Control" },
  { icon: "cookie", label: "Cookie" },
  { icon: "cooking-pot", label: "Cooking pot" },
  { icon: "copy", label: "Copy" },
  { icon: "copy-simple", label: "Copy simple" },
  { icon: "copyleft", label: "Copyleft" },
  { icon: "copyright", label: "Copyright" },
  { icon: "corners-in", label: "Corners in" },
  { icon: "corners-out", label: "Corners out" },
  { icon: "couch", label: "Couch" },
  { icon: "court-basketball", label: "Court basketball" },
  { icon: "cow", label: "Cow" },
  { icon: "cowboy-hat", label: "Cowboy hat" },
  { icon: "cpu", label: "Cpu" },
  { icon: "crane", label: "Crane" },
  { icon: "crane-tower", label: "Crane tower" },
  { icon: "credit-card", label: "Credit card" },
  { icon: "cricket", label: "Cricket" },
  { icon: "crop", label: "Crop" },
  { icon: "cross", label: "Cross" },
  { icon: "crosshair", label: "Crosshair" },
  { icon: "crosshair-simple", label: "Crosshair simple" },
  { icon: "crown", label: "Crown" },
  { icon: "crown-cross", label: "Crown cross" },
  { icon: "crown-simple", label: "Crown simple" },
  { icon: "cube", label: "Cube" },
  { icon: "cube-focus", label: "Cube focus" },
  { icon: "cube-transparent", label: "Cube transparent" },
  { icon: "currency-btc", label: "Currency btc" },
  { icon: "currency-circle-dollar", label: "Currency circle dollar" },
  { icon: "currency-cny", label: "Currency cny" },
  { icon: "currency-dollar", label: "Currency dollar" },
  { icon: "currency-dollar-simple", label: "Currency dollar simple" },
  { icon: "currency-eth", label: "Currency eth" },
  { icon: "currency-eur", label: "Currency eur" },
  { icon: "currency-gbp", label: "Currency gbp" },
  { icon: "currency-inr", label: "Currency inr" },
  { icon: "currency-jpy", label: "Currency jpy" },
  { icon: "currency-krw", label: "Currency krw" },
  { icon: "currency-kzt", label: "Currency kzt" },
  { icon: "currency-ngn", label: "Currency ngn" },
  { icon: "currency-rub", label: "Currency rub" },
  { icon: "cursor", label: "Cursor" },
  { icon: "cursor-click", label: "Cursor click" },
  { icon: "cursor-text", label: "Cursor text" },
  { icon: "cylinder", label: "Cylinder" },
  { icon: "database", label: "Database" },
  { icon: "desk", label: "Desk" },
  { icon: "desktop", label: "Desktop" },
  { icon: "desktop-tower", label: "Desktop tower" },
  { icon: "detective", label: "Detective" },
  { icon: "dev-to-logo", label: "Dev to logo" },
  { icon: "device-mobile", label: "Device mobile" },
  { icon: "device-mobile-camera", label: "Device mobile camera" },
  { icon: "device-mobile-slash", label: "Device mobile slash" },
  { icon: "device-mobile-speaker", label: "Device mobile speaker" },
  { icon: "device-rotate", label: "Device rotate" },
  { icon: "device-tablet", label: "Device tablet" },
  { icon: "device-tablet-camera", label: "Device tablet camera" },
  { icon: "device-tablet-speaker", label: "Device tablet speaker" },
  { icon: "devices", label: "Devices" },
  { icon: "diamond", label: "Diamond" },
  { icon: "diamonds-four", label: "Diamonds four" },
  { icon: "dice-five", label: "Dice five" },
  { icon: "dice-four", label: "Dice four" },
  { icon: "dice-one", label: "Dice one" },
  { icon: "dice-six", label: "Dice six" },
  { icon: "dice-three", label: "Dice three" },
  { icon: "dice-two", label: "Dice two" },
  { icon: "disc", label: "Disc" },
  { icon: "disco-ball", label: "Disco ball" },
  { icon: "discord-logo", label: "Discord logo" },
  { icon: "divide", label: "Divide" },
  { icon: "dna", label: "Dna" },
  { icon: "dog", label: "Dog" },
  { icon: "door", label: "Door" },
  { icon: "door-open", label: "Door open" },
  { icon: "dot", label: "Dot" },
  { icon: "dot-outline", label: "Dot outline" },
  { icon: "dots-nine", label: "Dots nine" },
  { icon: "dots-six", label: "Dots six" },
  { icon: "dots-six-vertical", label: "Dots six vertical" },
  { icon: "dots-three", label: "Dots three" },
  { icon: "dots-three-circle", label: "Dots three circle" },
  { icon: "dots-three-circle-vertical", label: "Dots three circle vertical" },
  { icon: "dots-three-outline", label: "Dots three outline" },
  { icon: "dots-three-outline-vertical", label: "Dots three outline vertical" },
  { icon: "dots-three-vertical", label: "Dots three vertical" },
  { icon: "download", label: "Download" },
  { icon: "download-simple", label: "Download simple" },
  { icon: "dress", label: "Dress" },
  { icon: "dresser", label: "Dresser" },
  { icon: "dribbble-logo", label: "Dribbble logo" },
  { icon: "drone", label: "Drone" },
  { icon: "drop", label: "Drop" },
  { icon: "drop-half", label: "Drop half" },
  { icon: "drop-half-bottom", label: "Drop half bottom" },
  { icon: "drop-simple", label: "Drop simple" },
  { icon: "drop-slash", label: "Drop slash" },
  { icon: "dropbox-logo", label: "Dropbox logo" },
  { icon: "ear", label: "Ear" },
  { icon: "ear-slash", label: "Ear slash" },
  { icon: "egg", label: "Egg" },
  { icon: "egg-crack", label: "Egg crack" },
  { icon: "eject", label: "Eject" },
  { icon: "eject-simple", label: "Eject simple" },
  { icon: "elevator", label: "Elevator" },
  { icon: "empty", label: "Empty" },
  { icon: "engine", label: "Engine" },
  { icon: "envelope", label: "Envelope" },
  { icon: "envelope-open", label: "Envelope open" },
  { icon: "envelope-simple", label: "Envelope simple" },
  { icon: "envelope-simple-open", label: "Envelope simple open" },
  { icon: "equalizer", label: "Equalizer" },
  { icon: "equals", label: "Equals" },
  { icon: "eraser", label: "Eraser" },
  { icon: "escalator-down", label: "Escalator down" },
  { icon: "escalator-up", label: "Escalator up" },
  { icon: "exam", label: "Exam" },
  { icon: "exclamation-mark", label: "Exclamation mark" },
  { icon: "exclude", label: "Exclude" },
  { icon: "exclude-square", label: "Exclude square" },
  { icon: "export", label: "Export" },
  { icon: "eye", label: "Eye" },
  { icon: "eye-closed", label: "Eye closed" },
  { icon: "eye-slash", label: "Eye slash" },
  { icon: "eyedropper", label: "Eyedropper" },
  { icon: "eyedropper-sample", label: "Eyedropper sample" },
  { icon: "eyeglasses", label: "Eyeglasses" },
  { icon: "eyes", label: "Eyes" },
  { icon: "face-mask", label: "Face mask" },
  { icon: "facebook-logo", label: "Facebook logo" },
  { icon: "factory", label: "Factory" },
  { icon: "faders", label: "Faders" },
  { icon: "faders-horizontal", label: "Faders horizontal" },
  { icon: "fallout-shelter", label: "Fallout shelter" },
  { icon: "fan", label: "Fan" },
  { icon: "farm", label: "Farm" },
  { icon: "fast-forward", label: "Fast forward" },
  { icon: "fast-forward-circle", label: "Fast forward circle" },
  { icon: "feather", label: "Feather" },
  { icon: "fediverse-logo", label: "Fediverse logo" },
  { icon: "figma-logo", label: "Figma logo" },
  { icon: "file", label: "File" },
  { icon: "file-archive", label: "File archive" },
  { icon: "file-arrow-down", label: "File arrow down" },
  { icon: "file-arrow-up", label: "File arrow up" },
  { icon: "file-audio", label: "File audio" },
  { icon: "file-c", label: "File c" },
  { icon: "file-c-sharp", label: "File c sharp" },
  { icon: "file-cloud", label: "File cloud" },
  { icon: "file-code", label: "File code" },
  { icon: "file-cpp", label: "File cpp" },
  { icon: "file-css", label: "File css" },
  { icon: "file-csv", label: "File csv" },
  { icon: "file-dashed, file-dotted", label: "File dashed, file dotted" },
  { icon: "file-doc", label: "File doc" },
  { icon: "file-html", label: "File html" },
  { icon: "file-image", label: "File image" },
  { icon: "file-ini", label: "File ini" },
  { icon: "file-jpg", label: "File jpg" },
  { icon: "file-js", label: "File js" },
  { icon: "file-jsx", label: "File jsx" },
  { icon: "file-lock", label: "File lock" },
  { icon: "file-magnifying-glass, file-search", label: "File magnifying glass, file search" },
  { icon: "file-md", label: "File md" },
  { icon: "file-minus", label: "File minus" },
  { icon: "file-pdf", label: "File pdf" },
  { icon: "file-plus", label: "File plus" },
  { icon: "file-png", label: "File png" },
  { icon: "file-ppt", label: "File ppt" },
  { icon: "file-py", label: "File py" },
  { icon: "file-rs", label: "File rs" },
  { icon: "file-sql", label: "File sql" },
  { icon: "file-svg", label: "File svg" },
  { icon: "file-text", label: "File text" },
  { icon: "file-ts", label: "File ts" },
  { icon: "file-tsx", label: "File tsx" },
  { icon: "file-txt", label: "File txt" },
  { icon: "file-video", label: "File video" },
  { icon: "file-vue", label: "File vue" },
  { icon: "file-x", label: "File x" },
  { icon: "file-xls", label: "File xls" },
  { icon: "file-zip", label: "File zip" },
  { icon: "files", label: "Files" },
  { icon: "film-reel", label: "Film reel" },
  { icon: "film-script", label: "Film script" },
  { icon: "film-slate", label: "Film slate" },
  { icon: "film-strip", label: "Film strip" },
  { icon: "fingerprint", label: "Fingerprint" },
  { icon: "fingerprint-simple", label: "Fingerprint simple" },
  { icon: "finn-the-human", label: "Finn the human" },
  { icon: "fire", label: "Fire" },
  { icon: "fire-extinguisher", label: "Fire extinguisher" },
  { icon: "fire-simple", label: "Fire simple" },
  { icon: "fire-truck", label: "Fire truck" },
  { icon: "first-aid", label: "First aid" },
  { icon: "first-aid-kit", label: "First aid kit" },
  { icon: "fish", label: "Fish" },
  { icon: "fish-simple", label: "Fish simple" },
  { icon: "flag", label: "Flag" },
  { icon: "flag-banner", label: "Flag banner" },
  { icon: "flag-banner-fold", label: "Flag banner fold" },
  { icon: "flag-checkered", label: "Flag checkered" },
  { icon: "flag-pennant", label: "Flag pennant" },
  { icon: "flame", label: "Flame" },
  { icon: "flashlight", label: "Flashlight" },
  { icon: "flask", label: "Flask" },
  { icon: "flip-horizontal", label: "Flip horizontal" },
  { icon: "flip-vertical", label: "Flip vertical" },
  { icon: "floppy-disk", label: "Floppy disk" },
  { icon: "floppy-disk-back", label: "Floppy disk back" },
  { icon: "flow-arrow", label: "Flow arrow" },
  { icon: "flower", label: "Flower" },
  { icon: "flower-lotus", label: "Flower lotus" },
  { icon: "flower-tulip", label: "Flower tulip" },
  { icon: "flying-saucer", label: "Flying saucer" },
  { icon: "folder, folder-notch", label: "Folder, folder notch" },
  { icon: "folder-dashed, folder-dotted", label: "Folder dashed, folder dotted" },
  { icon: "folder-lock", label: "Folder lock" },
  { icon: "folder-minus, folder-notch-minus", label: "Folder minus, folder notch minus" },
  { icon: "folder-open, folder-notch-open", label: "Folder open, folder notch open" },
  { icon: "folder-plus, folder-notch-plus", label: "Folder plus, folder notch plus" },
  { icon: "folder-simple", label: "Folder simple" },
  { icon: "folder-simple-dashed, folder-simple-dotted", label: "Folder simple dashed, folder simple dotted" },
  { icon: "folder-simple-lock", label: "Folder simple lock" },
  { icon: "folder-simple-minus", label: "Folder simple minus" },
  { icon: "folder-simple-plus", label: "Folder simple plus" },
  { icon: "folder-simple-star", label: "Folder simple star" },
  { icon: "folder-simple-user", label: "Folder simple user" },
  { icon: "folder-star", label: "Folder star" },
  { icon: "folder-user", label: "Folder user" },
  { icon: "folders", label: "Folders" },
  { icon: "football", label: "Football" },
  { icon: "football-helmet", label: "Football helmet" },
  { icon: "footprints", label: "Footprints" },
  { icon: "fork-knife", label: "Fork knife" },
  { icon: "four-k", label: "Four k" },
  { icon: "frame-corners", label: "Frame corners" },
  { icon: "framer-logo", label: "Framer logo" },
  { icon: "function", label: "Function" },
  { icon: "funnel", label: "Funnel" },
  { icon: "funnel-simple", label: "Funnel simple" },
  { icon: "funnel-simple-x", label: "Funnel simple x" },
  { icon: "funnel-x", label: "Funnel x" },
  { icon: "game-controller", label: "Game controller" },
  { icon: "garage", label: "Garage" },
  { icon: "gas-can", label: "Gas can" },
  { icon: "gas-pump", label: "Gas pump" },
  { icon: "gauge", label: "Gauge" },
  { icon: "gavel", label: "Gavel" },
  { icon: "gear", label: "Gear" },
  { icon: "gear-fine", label: "Gear fine" },
  { icon: "gear-six", label: "Gear six" },
  { icon: "gender-female", label: "Gender female" },
  { icon: "gender-intersex", label: "Gender intersex" },
  { icon: "gender-male", label: "Gender male" },
  { icon: "gender-neuter", label: "Gender neuter" },
  { icon: "gender-nonbinary", label: "Gender nonbinary" },
  { icon: "gender-transgender", label: "Gender transgender" },
  { icon: "ghost", label: "Ghost" },
  { icon: "gif", label: "Gif" },
  { icon: "gift", label: "Gift" },
  { icon: "git-branch", label: "Git branch" },
  { icon: "git-commit", label: "Git commit" },
  { icon: "git-diff", label: "Git diff" },
  { icon: "git-fork", label: "Git fork" },
  { icon: "git-merge", label: "Git merge" },
  { icon: "git-pull-request", label: "Git pull request" },
  { icon: "github-logo", label: "Github logo" },
  { icon: "gitlab-logo", label: "Gitlab logo" },
  { icon: "gitlab-logo-simple", label: "Gitlab logo simple" },
  { icon: "globe", label: "Globe" },
  { icon: "globe-hemisphere-east", label: "Globe hemisphere east" },
  { icon: "globe-hemisphere-west", label: "Globe hemisphere west" },
  { icon: "globe-simple", label: "Globe simple" },
  { icon: "globe-simple-x", label: "Globe simple x" },
  { icon: "globe-stand", label: "Globe stand" },
  { icon: "globe-x", label: "Globe x" },
  { icon: "goggles", label: "Goggles" },
  { icon: "golf", label: "Golf" },
  { icon: "goodreads-logo", label: "Goodreads logo" },
  { icon: "google-cardboard-logo", label: "Google cardboard logo" },
  { icon: "google-chrome-logo", label: "Google chrome logo" },
  { icon: "google-drive-logo", label: "Google drive logo" },
  { icon: "google-logo", label: "Google logo" },
  { icon: "google-photos-logo", label: "Google photos logo" },
  { icon: "google-play-logo", label: "Google play logo" },
  { icon: "google-podcasts-logo", label: "Google podcasts logo" },
  { icon: "gps", label: "Gps" },
  { icon: "gps-fix", label: "Gps fix" },
  { icon: "gps-slash", label: "Gps slash" },
  { icon: "gradient", label: "Gradient" },
  { icon: "graduation-cap", label: "Graduation cap" },
  { icon: "grains", label: "Grains" },
  { icon: "grains-slash", label: "Grains slash" },
  { icon: "graph", label: "Graph" },
  { icon: "graphics-card", label: "Graphics card" },
  { icon: "greater-than", label: "Greater than" },
  { icon: "greater-than-or-equal", label: "Greater than or equal" },
  { icon: "grid-four", label: "Grid four" },
  { icon: "grid-nine", label: "Grid nine" },
  { icon: "guitar", label: "Guitar" },
  { icon: "hair-dryer", label: "Hair dryer" },
  { icon: "hamburger", label: "Hamburger" },
  { icon: "hammer", label: "Hammer" },
  { icon: "hand", label: "Hand" },
  { icon: "hand-arrow-down", label: "Hand arrow down" },
  { icon: "hand-arrow-up", label: "Hand arrow up" },
  { icon: "hand-coins", label: "Hand coins" },
  { icon: "hand-deposit", label: "Hand deposit" },
  { icon: "hand-eye", label: "Hand eye" },
  { icon: "hand-fist", label: "Hand fist" },
  { icon: "hand-grabbing", label: "Hand grabbing" },
  { icon: "hand-heart", label: "Hand heart" },
  { icon: "hand-palm", label: "Hand palm" },
  { icon: "hand-peace", label: "Hand peace" },
  { icon: "hand-pointing", label: "Hand pointing" },
  { icon: "hand-soap", label: "Hand soap" },
  { icon: "hand-swipe-left", label: "Hand swipe left" },
  { icon: "hand-swipe-right", label: "Hand swipe right" },
  { icon: "hand-tap", label: "Hand tap" },
  { icon: "hand-waving", label: "Hand waving" },
  { icon: "hand-withdraw", label: "Hand withdraw" },
  { icon: "handbag", label: "Handbag" },
  { icon: "handbag-simple", label: "Handbag simple" },
  { icon: "hands-clapping", label: "Hands clapping" },
  { icon: "hands-praying", label: "Hands praying" },
  { icon: "handshake", label: "Handshake" },
  { icon: "hard-drive", label: "Hard drive" },
  { icon: "hard-drives", label: "Hard drives" },
  { icon: "hard-hat", label: "Hard hat" },
  { icon: "hash", label: "Hash" },
  { icon: "hash-straight", label: "Hash straight" },
  { icon: "head-circuit", label: "Head circuit" },
  { icon: "headlights", label: "Headlights" },
  { icon: "headphones", label: "Headphones" },
  { icon: "headset", label: "Headset" },
  { icon: "heart", label: "Heart" },
  { icon: "heart-break", label: "Heart break" },
  { icon: "heart-half", label: "Heart half" },
  { icon: "heart-straight", label: "Heart straight" },
  { icon: "heart-straight-break", label: "Heart straight break" },
  { icon: "heartbeat", label: "Heartbeat" },
  { icon: "hexagon", label: "Hexagon" },
  { icon: "high-definition", label: "High definition" },
  { icon: "high-heel", label: "High heel" },
  { icon: "highlighter", label: "Highlighter" },
  { icon: "highlighter-circle", label: "Highlighter circle" },
  { icon: "hockey", label: "Hockey" },
  { icon: "hoodie", label: "Hoodie" },
  { icon: "horse", label: "Horse" },
  { icon: "hospital", label: "Hospital" },
  { icon: "hourglass", label: "Hourglass" },
  { icon: "hourglass-high", label: "Hourglass high" },
  { icon: "hourglass-low", label: "Hourglass low" },
  { icon: "hourglass-medium", label: "Hourglass medium" },
  { icon: "hourglass-simple", label: "Hourglass simple" },
  { icon: "hourglass-simple-high", label: "Hourglass simple high" },
  { icon: "hourglass-simple-low", label: "Hourglass simple low" },
  { icon: "hourglass-simple-medium", label: "Hourglass simple medium" },
  { icon: "house", label: "House" },
  { icon: "house-line", label: "House line" },
  { icon: "house-simple", label: "House simple" },
  { icon: "hurricane", label: "Hurricane" },
  { icon: "ice-cream", label: "Ice cream" },
  { icon: "identification-badge", label: "Identification badge" },
  { icon: "identification-card", label: "Identification card" },
  { icon: "image", label: "Image" },
  { icon: "image-broken", label: "Image broken" },
  { icon: "image-square", label: "Image square" },
  { icon: "images", label: "Images" },
  { icon: "images-square", label: "Images square" },
  { icon: "infinity, lemniscate", label: "Infinity, lemniscate" },
  { icon: "info", label: "Info" },
  { icon: "instagram-logo", label: "Instagram logo" },
  { icon: "intersect", label: "Intersect" },
  { icon: "intersect-square", label: "Intersect square" },
  { icon: "intersect-three", label: "Intersect three" },
  { icon: "intersection", label: "Intersection" },
  { icon: "invoice", label: "Invoice" },
  { icon: "island", label: "Island" },
  { icon: "jar", label: "Jar" },
  { icon: "jar-label", label: "Jar label" },
  { icon: "jeep", label: "Jeep" },
  { icon: "joystick", label: "Joystick" },
  { icon: "kanban", label: "Kanban" },
  { icon: "key", label: "Key" },
  { icon: "key-return", label: "Key return" },
  { icon: "keyboard", label: "Keyboard" },
  { icon: "keyhole", label: "Keyhole" },
  { icon: "knife", label: "Knife" },
  { icon: "ladder", label: "Ladder" },
  { icon: "ladder-simple", label: "Ladder simple" },
  { icon: "lamp", label: "Lamp" },
  { icon: "lamp-pendant", label: "Lamp pendant" },
  { icon: "laptop", label: "Laptop" },
  { icon: "lasso", label: "Lasso" },
  { icon: "lastfm-logo", label: "Lastfm logo" },
  { icon: "layout", label: "Layout" },
  { icon: "leaf", label: "Leaf" },
  { icon: "lectern", label: "Lectern" },
  { icon: "lego", label: "Lego" },
  { icon: "lego-smiley", label: "Lego smiley" },
  { icon: "less-than", label: "Less than" },
  { icon: "less-than-or-equal", label: "Less than or equal" },
  { icon: "letter-circle-h", label: "Letter circle h" },
  { icon: "letter-circle-p", label: "Letter circle p" },
  { icon: "letter-circle-v", label: "Letter circle v" },
  { icon: "lifebuoy", label: "Lifebuoy" },
  { icon: "lightbulb", label: "Lightbulb" },
  { icon: "lightbulb-filament", label: "Lightbulb filament" },
  { icon: "lighthouse", label: "Lighthouse" },
  { icon: "lightning", label: "Lightning" },
  { icon: "lightning-a", label: "Lightning a" },
  { icon: "lightning-slash", label: "Lightning slash" },
  { icon: "line-segment", label: "Line segment" },
  { icon: "line-segments", label: "Line segments" },
  { icon: "line-vertical", label: "Line vertical" },
  { icon: "link", label: "Link" },
  { icon: "link-break", label: "Link break" },
  { icon: "link-simple", label: "Link simple" },
  { icon: "link-simple-break", label: "Link simple break" },
  { icon: "link-simple-horizontal", label: "Link simple horizontal" },
  { icon: "link-simple-horizontal-break", label: "Link simple horizontal break" },
  { icon: "linkedin-logo", label: "Linkedin logo" },
  { icon: "linktree-logo", label: "Linktree logo" },
  { icon: "linux-logo", label: "Linux logo" },
  { icon: "list", label: "List" },
  { icon: "list-bullets", label: "List bullets" },
  { icon: "list-checks", label: "List checks" },
  { icon: "list-dashes", label: "List dashes" },
  { icon: "list-heart", label: "List heart" },
  { icon: "list-magnifying-glass", label: "List magnifying glass" },
  { icon: "list-numbers", label: "List numbers" },
  { icon: "list-plus", label: "List plus" },
  { icon: "list-star", label: "List star" },
  { icon: "lock", label: "Lock" },
  { icon: "lock-key", label: "Lock key" },
  { icon: "lock-key-open", label: "Lock key open" },
  { icon: "lock-laminated", label: "Lock laminated" },
  { icon: "lock-laminated-open", label: "Lock laminated open" },
  { icon: "lock-open", label: "Lock open" },
  { icon: "lock-simple", label: "Lock simple" },
  { icon: "lock-simple-open", label: "Lock simple open" },
  { icon: "lockers", label: "Lockers" },
  { icon: "log", label: "Log" },
  { icon: "magic-wand", label: "Magic wand" },
  { icon: "magnet", label: "Magnet" },
  { icon: "magnet-straight", label: "Magnet straight" },
  { icon: "magnifying-glass", label: "Magnifying glass" },
  { icon: "magnifying-glass-minus", label: "Magnifying glass minus" },
  { icon: "magnifying-glass-plus", label: "Magnifying glass plus" },
  { icon: "mailbox", label: "Mailbox" },
  { icon: "map-pin", label: "Map pin" },
  { icon: "map-pin-area", label: "Map pin area" },
  { icon: "map-pin-line", label: "Map pin line" },
  { icon: "map-pin-plus", label: "Map pin plus" },
  { icon: "map-pin-simple", label: "Map pin simple" },
  { icon: "map-pin-simple-area", label: "Map pin simple area" },
  { icon: "map-pin-simple-line", label: "Map pin simple line" },
  { icon: "map-trifold", label: "Map trifold" },
  { icon: "markdown-logo", label: "Markdown logo" },
  { icon: "marker-circle", label: "Marker circle" },
  { icon: "martini", label: "Martini" },
  { icon: "mask-happy", label: "Mask happy" },
  { icon: "mask-sad", label: "Mask sad" },
  { icon: "mastodon-logo", label: "Mastodon logo" },
  { icon: "math-operations", label: "Math operations" },
  { icon: "matrix-logo", label: "Matrix logo" },
  { icon: "medal", label: "Medal" },
  { icon: "medal-military", label: "Medal military" },
  { icon: "medium-logo", label: "Medium logo" },
  { icon: "megaphone", label: "Megaphone" },
  { icon: "megaphone-simple", label: "Megaphone simple" },
  { icon: "member-of", label: "Member of" },
  { icon: "memory", label: "Memory" },
  { icon: "messenger-logo", label: "Messenger logo" },
  { icon: "meta-logo", label: "Meta logo" },
  { icon: "meteor", label: "Meteor" },
  { icon: "metronome", label: "Metronome" },
  { icon: "microphone", label: "Microphone" },
  { icon: "microphone-slash", label: "Microphone slash" },
  { icon: "microphone-stage", label: "Microphone stage" },
  { icon: "microscope", label: "Microscope" },
  { icon: "microsoft-excel-logo", label: "Microsoft excel logo" },
  { icon: "microsoft-outlook-logo", label: "Microsoft outlook logo" },
  { icon: "microsoft-powerpoint-logo", label: "Microsoft powerpoint logo" },
  { icon: "microsoft-teams-logo", label: "Microsoft teams logo" },
  { icon: "microsoft-word-logo", label: "Microsoft word logo" },
  { icon: "minus", label: "Minus" },
  { icon: "minus-circle", label: "Minus circle" },
  { icon: "minus-square", label: "Minus square" },
  { icon: "money", label: "Money" },
  { icon: "money-wavy", label: "Money wavy" },
  { icon: "monitor", label: "Monitor" },
  { icon: "monitor-arrow-up", label: "Monitor arrow up" },
  { icon: "monitor-play", label: "Monitor play" },
  { icon: "moon", label: "Moon" },
  { icon: "moon-stars", label: "Moon stars" },
  { icon: "moped", label: "Moped" },
  { icon: "moped-front", label: "Moped front" },
  { icon: "mosque", label: "Mosque" },
  { icon: "motorcycle", label: "Motorcycle" },
  { icon: "mountains", label: "Mountains" },
  { icon: "mouse", label: "Mouse" },
  { icon: "mouse-left-click", label: "Mouse left click" },
  { icon: "mouse-middle-click", label: "Mouse middle click" },
  { icon: "mouse-right-click", label: "Mouse right click" },
  { icon: "mouse-scroll", label: "Mouse scroll" },
  { icon: "mouse-simple", label: "Mouse simple" },
  { icon: "music-note", label: "Music note" },
  { icon: "music-note-simple", label: "Music note simple" },
  { icon: "music-notes", label: "Music notes" },
  { icon: "music-notes-minus", label: "Music notes minus" },
  { icon: "music-notes-plus", label: "Music notes plus" },
  { icon: "music-notes-simple", label: "Music notes simple" },
  { icon: "navigation-arrow", label: "Navigation arrow" },
  { icon: "needle", label: "Needle" },
  { icon: "network", label: "Network" },
  { icon: "network-slash", label: "Network slash" },
  { icon: "network-x", label: "Network x" },
  { icon: "newspaper", label: "Newspaper" },
  { icon: "newspaper-clipping", label: "Newspaper clipping" },
  { icon: "not-equals", label: "Not equals" },
  { icon: "not-member-of", label: "Not member of" },
  { icon: "not-subset-of", label: "Not subset of" },
  { icon: "not-superset-of", label: "Not superset of" },
  { icon: "notches", label: "Notches" },
  { icon: "note", label: "Note" },
  { icon: "note-blank", label: "Note blank" },
  { icon: "note-pencil", label: "Note pencil" },
  { icon: "notebook", label: "Notebook" },
  { icon: "notepad", label: "Notepad" },
  { icon: "notification", label: "Notification" },
  { icon: "notion-logo", label: "Notion logo" },
  { icon: "nuclear-plant", label: "Nuclear plant" },
  { icon: "number-circle-eight", label: "Number circle eight" },
  { icon: "number-circle-five", label: "Number circle five" },
  { icon: "number-circle-four", label: "Number circle four" },
  { icon: "number-circle-nine", label: "Number circle nine" },
  { icon: "number-circle-one", label: "Number circle one" },
  { icon: "number-circle-seven", label: "Number circle seven" },
  { icon: "number-circle-six", label: "Number circle six" },
  { icon: "number-circle-three", label: "Number circle three" },
  { icon: "number-circle-two", label: "Number circle two" },
  { icon: "number-circle-zero", label: "Number circle zero" },
  { icon: "number-eight", label: "Number eight" },
  { icon: "number-five", label: "Number five" },
  { icon: "number-four", label: "Number four" },
  { icon: "number-nine", label: "Number nine" },
  { icon: "number-one", label: "Number one" },
  { icon: "number-seven", label: "Number seven" },
  { icon: "number-six", label: "Number six" },
  { icon: "number-square-eight", label: "Number square eight" },
  { icon: "number-square-five", label: "Number square five" },
  { icon: "number-square-four", label: "Number square four" },
  { icon: "number-square-nine", label: "Number square nine" },
  { icon: "number-square-one", label: "Number square one" },
  { icon: "number-square-seven", label: "Number square seven" },
  { icon: "number-square-six", label: "Number square six" },
  { icon: "number-square-three", label: "Number square three" },
  { icon: "number-square-two", label: "Number square two" },
  { icon: "number-square-zero", label: "Number square zero" },
  { icon: "number-three", label: "Number three" },
  { icon: "number-two", label: "Number two" },
  { icon: "number-zero", label: "Number zero" },
  { icon: "numpad", label: "Numpad" },
  { icon: "nut", label: "Nut" },
  { icon: "ny-times-logo", label: "Ny times logo" },
  { icon: "octagon", label: "Octagon" },
  { icon: "office-chair", label: "Office chair" },
  { icon: "onigiri", label: "Onigiri" },
  { icon: "open-ai-logo", label: "Open ai logo" },
  { icon: "option", label: "Option" },
  { icon: "orange", label: "Orange" },
  { icon: "orange-slice", label: "Orange slice" },
  { icon: "oven", label: "Oven" },
  { icon: "package", label: "Package" },
  { icon: "paint-brush", label: "Paint brush" },
  { icon: "paint-brush-broad", label: "Paint brush broad" },
  { icon: "paint-brush-household", label: "Paint brush household" },
  { icon: "paint-bucket", label: "Paint bucket" },
  { icon: "paint-roller", label: "Paint roller" },
  { icon: "palette", label: "Palette" },
  { icon: "panorama", label: "Panorama" },
  { icon: "pants", label: "Pants" },
  { icon: "paper-plane", label: "Paper plane" },
  { icon: "paper-plane-right", label: "Paper plane right" },
  { icon: "paper-plane-tilt", label: "Paper plane tilt" },
  { icon: "paperclip", label: "Paperclip" },
  { icon: "paperclip-horizontal", label: "Paperclip horizontal" },
  { icon: "parachute", label: "Parachute" },
  { icon: "paragraph", label: "Paragraph" },
  { icon: "parallelogram", label: "Parallelogram" },
  { icon: "park", label: "Park" },
  { icon: "password", label: "Password" },
  { icon: "path", label: "Path" },
  { icon: "patreon-logo", label: "Patreon logo" },
  { icon: "pause", label: "Pause" },
  { icon: "pause-circle", label: "Pause circle" },
  { icon: "paw-print", label: "Paw print" },
  { icon: "paypal-logo", label: "Paypal logo" },
  { icon: "peace", label: "Peace" },
  { icon: "pen", label: "Pen" },
  { icon: "pen-nib", label: "Pen nib" },
  { icon: "pen-nib-straight", label: "Pen nib straight" },
  { icon: "pencil", label: "Pencil" },
  { icon: "pencil-circle", label: "Pencil circle" },
  { icon: "pencil-line", label: "Pencil line" },
  { icon: "pencil-ruler", label: "Pencil ruler" },
  { icon: "pencil-simple", label: "Pencil simple" },
  { icon: "pencil-simple-line", label: "Pencil simple line" },
  { icon: "pencil-simple-slash", label: "Pencil simple slash" },
  { icon: "pencil-slash", label: "Pencil slash" },
  { icon: "pentagon", label: "Pentagon" },
  { icon: "pentagram", label: "Pentagram" },
  { icon: "pepper", label: "Pepper" },
  { icon: "percent", label: "Percent" },
  { icon: "person", label: "Person" },
  { icon: "person-arms-spread", label: "Person arms spread" },
  { icon: "person-simple", label: "Person simple" },
  { icon: "person-simple-bike", label: "Person simple bike" },
  { icon: "person-simple-circle", label: "Person simple circle" },
  { icon: "person-simple-hike", label: "Person simple hike" },
  { icon: "person-simple-run", label: "Person simple run" },
  { icon: "person-simple-ski", label: "Person simple ski" },
  { icon: "person-simple-snowboard", label: "Person simple snowboard" },
  { icon: "person-simple-swim", label: "Person simple swim" },
  { icon: "person-simple-tai-chi", label: "Person simple tai chi" },
  { icon: "person-simple-throw", label: "Person simple throw" },
  { icon: "person-simple-walk", label: "Person simple walk" },
  { icon: "perspective", label: "Perspective" },
  { icon: "phone", label: "Phone" },
  { icon: "phone-call", label: "Phone call" },
  { icon: "phone-disconnect", label: "Phone disconnect" },
  { icon: "phone-incoming", label: "Phone incoming" },
  { icon: "phone-list", label: "Phone list" },
  { icon: "phone-outgoing", label: "Phone outgoing" },
  { icon: "phone-pause", label: "Phone pause" },
  { icon: "phone-plus", label: "Phone plus" },
  { icon: "phone-slash", label: "Phone slash" },
  { icon: "phone-transfer", label: "Phone transfer" },
  { icon: "phone-x", label: "Phone x" },
  { icon: "phosphor-logo", label: "Phosphor logo" },
  { icon: "pi", label: "Pi" },
  { icon: "piano-keys", label: "Piano keys" },
  { icon: "picnic-table", label: "Picnic table" },
  { icon: "picture-in-picture", label: "Picture in picture" },
  { icon: "piggy-bank", label: "Piggy bank" },
  { icon: "pill", label: "Pill" },
  { icon: "ping-pong", label: "Ping pong" },
  { icon: "pint-glass", label: "Pint glass" },
  { icon: "pinterest-logo", label: "Pinterest logo" },
  { icon: "pinwheel", label: "Pinwheel" },
  { icon: "pipe", label: "Pipe" },
  { icon: "pipe-wrench", label: "Pipe wrench" },
  { icon: "pix-logo", label: "Pix logo" },
  { icon: "pizza", label: "Pizza" },
  { icon: "placeholder", label: "Placeholder" },
  { icon: "planet", label: "Planet" },
  { icon: "plant", label: "Plant" },
  { icon: "play", label: "Play" },
  { icon: "play-circle", label: "Play circle" },
  { icon: "play-pause", label: "Play pause" },
  { icon: "playlist", label: "Playlist" },
  { icon: "plug", label: "Plug" },
  { icon: "plug-charging", label: "Plug charging" },
  { icon: "plugs", label: "Plugs" },
  { icon: "plugs-connected", label: "Plugs connected" },
  { icon: "plus", label: "Plus" },
  { icon: "plus-circle", label: "Plus circle" },
  { icon: "plus-minus", label: "Plus minus" },
  { icon: "plus-square", label: "Plus square" },
  { icon: "poker-chip", label: "Poker chip" },
  { icon: "police-car", label: "Police car" },
  { icon: "polygon", label: "Polygon" },
  { icon: "popcorn", label: "Popcorn" },
  { icon: "popsicle", label: "Popsicle" },
  { icon: "potted-plant", label: "Potted plant" },
  { icon: "power", label: "Power" },
  { icon: "prescription", label: "Prescription" },
  { icon: "presentation", label: "Presentation" },
  { icon: "presentation-chart", label: "Presentation chart" },
  { icon: "printer", label: "Printer" },
  { icon: "prohibit", label: "Prohibit" },
  { icon: "prohibit-inset", label: "Prohibit inset" },
  { icon: "projector-screen", label: "Projector screen" },
  { icon: "projector-screen-chart", label: "Projector screen chart" },
  { icon: "pulse, activity", label: "Pulse, activity" },
  { icon: "push-pin", label: "Push pin" },
  { icon: "push-pin-simple", label: "Push pin simple" },
  { icon: "push-pin-simple-slash", label: "Push pin simple slash" },
  { icon: "push-pin-slash", label: "Push pin slash" },
  { icon: "puzzle-piece", label: "Puzzle piece" },
  { icon: "qr-code", label: "Qr code" },
  { icon: "question", label: "Question" },
  { icon: "question-mark", label: "Question mark" },
  { icon: "queue", label: "Queue" },
  { icon: "quotes", label: "Quotes" },
  { icon: "rabbit", label: "Rabbit" },
  { icon: "racquet", label: "Racquet" },
  { icon: "radical", label: "Radical" },
  { icon: "radio", label: "Radio" },
  { icon: "radio-button", label: "Radio button" },
  { icon: "radioactive", label: "Radioactive" },
  { icon: "rainbow", label: "Rainbow" },
  { icon: "rainbow-cloud", label: "Rainbow cloud" },
  { icon: "ranking", label: "Ranking" },
  { icon: "read-cv-logo", label: "Read cv logo" },
  { icon: "receipt", label: "Receipt" },
  { icon: "receipt-x", label: "Receipt x" },
  { icon: "record", label: "Record" },
  { icon: "rectangle", label: "Rectangle" },
  { icon: "rectangle-dashed", label: "Rectangle dashed" },
  { icon: "recycle", label: "Recycle" },
  { icon: "reddit-logo", label: "Reddit logo" },
  { icon: "repeat", label: "Repeat" },
  { icon: "repeat-once", label: "Repeat once" },
  { icon: "replit-logo", label: "Replit logo" },
  { icon: "resize", label: "Resize" },
  { icon: "rewind", label: "Rewind" },
  { icon: "rewind-circle", label: "Rewind circle" },
  { icon: "road-horizon", label: "Road horizon" },
  { icon: "robot", label: "Robot" },
  { icon: "rocket", label: "Rocket" },
  { icon: "rocket-launch", label: "Rocket launch" },
  { icon: "rows", label: "Rows" },
  { icon: "rows-plus-bottom", label: "Rows plus bottom" },
  { icon: "rows-plus-top", label: "Rows plus top" },
  { icon: "rss", label: "Rss" },
  { icon: "rss-simple", label: "Rss simple" },
  { icon: "rug", label: "Rug" },
  { icon: "ruler", label: "Ruler" },
  { icon: "sailboat", label: "Sailboat" },
  { icon: "scales", label: "Scales" },
  { icon: "scan", label: "Scan" },
  { icon: "scan-smiley", label: "Scan smiley" },
  { icon: "scissors", label: "Scissors" },
  { icon: "scooter", label: "Scooter" },
  { icon: "screencast", label: "Screencast" },
  { icon: "screwdriver", label: "Screwdriver" },
  { icon: "scribble", label: "Scribble" },
  { icon: "scribble-loop", label: "Scribble loop" },
  { icon: "scroll", label: "Scroll" },
  { icon: "seal, circle-wavy", label: "Seal, circle wavy" },
  { icon: "seal-check, circle-wavy-check", label: "Seal check, circle wavy check" },
  { icon: "seal-percent", label: "Seal percent" },
  { icon: "seal-question, circle-wavy-question", label: "Seal question, circle wavy question" },
  { icon: "seal-warning, circle-wavy-warning", label: "Seal warning, circle wavy warning" },
  { icon: "seat", label: "Seat" },
  { icon: "seatbelt", label: "Seatbelt" },
  { icon: "security-camera", label: "Security camera" },
  { icon: "selection", label: "Selection" },
  { icon: "selection-all", label: "Selection all" },
  { icon: "selection-background", label: "Selection background" },
  { icon: "selection-foreground", label: "Selection foreground" },
  { icon: "selection-inverse", label: "Selection inverse" },
  { icon: "selection-plus", label: "Selection plus" },
  { icon: "selection-slash", label: "Selection slash" },
  { icon: "shapes", label: "Shapes" },
  { icon: "share", label: "Share" },
  { icon: "share-fat", label: "Share fat" },
  { icon: "share-network", label: "Share network" },
  { icon: "shield", label: "Shield" },
  { icon: "shield-check", label: "Shield check" },
  { icon: "shield-checkered", label: "Shield checkered" },
  { icon: "shield-chevron", label: "Shield chevron" },
  { icon: "shield-plus", label: "Shield plus" },
  { icon: "shield-slash", label: "Shield slash" },
  { icon: "shield-star", label: "Shield star" },
  { icon: "shield-warning", label: "Shield warning" },
  { icon: "shipping-container", label: "Shipping container" },
  { icon: "shirt-folded", label: "Shirt folded" },
  { icon: "shooting-star", label: "Shooting star" },
  { icon: "shopping-bag", label: "Shopping bag" },
  { icon: "shopping-bag-open", label: "Shopping bag open" },
  { icon: "shopping-cart", label: "Shopping cart" },
  { icon: "shopping-cart-simple", label: "Shopping cart simple" },
  { icon: "shovel", label: "Shovel" },
  { icon: "shower", label: "Shower" },
  { icon: "shrimp", label: "Shrimp" },
  { icon: "shuffle", label: "Shuffle" },
  { icon: "shuffle-angular", label: "Shuffle angular" },
  { icon: "shuffle-simple", label: "Shuffle simple" },
  { icon: "sidebar", label: "Sidebar" },
  { icon: "sidebar-simple", label: "Sidebar simple" },
  { icon: "sigma", label: "Sigma" },
  { icon: "sign-in", label: "Sign in" },
  { icon: "sign-out", label: "Sign out" },
  { icon: "signature", label: "Signature" },
  { icon: "signpost", label: "Signpost" },
  { icon: "sim-card", label: "Sim card" },
  { icon: "siren", label: "Siren" },
  { icon: "sketch-logo", label: "Sketch logo" },
  { icon: "skip-back", label: "Skip back" },
  { icon: "skip-back-circle", label: "Skip back circle" },
  { icon: "skip-forward", label: "Skip forward" },
  { icon: "skip-forward-circle", label: "Skip forward circle" },
  { icon: "skull", label: "Skull" },
  { icon: "skype-logo", label: "Skype logo" },
  { icon: "slack-logo", label: "Slack logo" },
  { icon: "sliders", label: "Sliders" },
  { icon: "sliders-horizontal", label: "Sliders horizontal" },
  { icon: "slideshow", label: "Slideshow" },
  { icon: "smiley", label: "Smiley" },
  { icon: "smiley-angry", label: "Smiley angry" },
  { icon: "smiley-blank", label: "Smiley blank" },
  { icon: "smiley-meh", label: "Smiley meh" },
  { icon: "smiley-melting", label: "Smiley melting" },
  { icon: "smiley-nervous", label: "Smiley nervous" },
  { icon: "smiley-sad", label: "Smiley sad" },
  { icon: "smiley-sticker", label: "Smiley sticker" },
  { icon: "smiley-wink", label: "Smiley wink" },
  { icon: "smiley-x-eyes", label: "Smiley x eyes" },
  { icon: "snapchat-logo", label: "Snapchat logo" },
  { icon: "sneaker", label: "Sneaker" },
  { icon: "sneaker-move", label: "Sneaker move" },
  { icon: "snowflake", label: "Snowflake" },
  { icon: "soccer-ball", label: "Soccer ball" },
  { icon: "sock", label: "Sock" },
  { icon: "solar-panel", label: "Solar panel" },
  { icon: "solar-roof", label: "Solar roof" },
  { icon: "sort-ascending", label: "Sort ascending" },
  { icon: "sort-descending", label: "Sort descending" },
  { icon: "soundcloud-logo", label: "Soundcloud logo" },
  { icon: "spade", label: "Spade" },
  { icon: "sparkle", label: "Sparkle" },
  { icon: "speaker-hifi", label: "Speaker hifi" },
  { icon: "speaker-high", label: "Speaker high" },
  { icon: "speaker-low", label: "Speaker low" },
  { icon: "speaker-none", label: "Speaker none" },
  { icon: "speaker-simple-high", label: "Speaker simple high" },
  { icon: "speaker-simple-low", label: "Speaker simple low" },
  { icon: "speaker-simple-none", label: "Speaker simple none" },
  { icon: "speaker-simple-slash", label: "Speaker simple slash" },
  { icon: "speaker-simple-x", label: "Speaker simple x" },
  { icon: "speaker-slash", label: "Speaker slash" },
  { icon: "speaker-x", label: "Speaker x" },
  { icon: "speedometer", label: "Speedometer" },
  { icon: "sphere", label: "Sphere" },
  { icon: "spinner", label: "Spinner" },
  { icon: "spinner-ball", label: "Spinner ball" },
  { icon: "spinner-gap", label: "Spinner gap" },
  { icon: "spiral", label: "Spiral" },
  { icon: "split-horizontal", label: "Split horizontal" },
  { icon: "split-vertical", label: "Split vertical" },
  { icon: "spotify-logo", label: "Spotify logo" },
  { icon: "spray-bottle", label: "Spray bottle" },
  { icon: "square", label: "Square" },
  { icon: "square-half", label: "Square half" },
  { icon: "square-half-bottom", label: "Square half bottom" },
  { icon: "square-logo", label: "Square logo" },
  { icon: "square-split-horizontal", label: "Square split horizontal" },
  { icon: "square-split-vertical", label: "Square split vertical" },
  { icon: "squares-four", label: "Squares four" },
  { icon: "stack", label: "Stack" },
  { icon: "stack-minus", label: "Stack minus" },
  { icon: "stack-overflow-logo", label: "Stack overflow logo" },
  { icon: "stack-plus", label: "Stack plus" },
  { icon: "stack-simple", label: "Stack simple" },
  { icon: "stairs", label: "Stairs" },
  { icon: "stamp", label: "Stamp" },
  { icon: "standard-definition", label: "Standard definition" },
  { icon: "star", label: "Star" },
  { icon: "star-and-crescent", label: "Star and crescent" },
  { icon: "star-four", label: "Star four" },
  { icon: "star-half", label: "Star half" },
  { icon: "star-of-david", label: "Star of david" },
  { icon: "steam-logo", label: "Steam logo" },
  { icon: "steering-wheel", label: "Steering wheel" },
  { icon: "steps", label: "Steps" },
  { icon: "stethoscope", label: "Stethoscope" },
  { icon: "sticker", label: "Sticker" },
  { icon: "stool", label: "Stool" },
  { icon: "stop", label: "Stop" },
  { icon: "stop-circle", label: "Stop circle" },
  { icon: "storefront", label: "Storefront" },
  { icon: "strategy", label: "Strategy" },
  { icon: "stripe-logo", label: "Stripe logo" },
  { icon: "student", label: "Student" },
  { icon: "subset-of", label: "Subset of" },
  { icon: "subset-proper-of", label: "Subset proper of" },
  { icon: "subtitles", label: "Subtitles" },
  { icon: "subtitles-slash", label: "Subtitles slash" },
  { icon: "subtract", label: "Subtract" },
  { icon: "subtract-square", label: "Subtract square" },
  { icon: "subway", label: "Subway" },
  { icon: "suitcase", label: "Suitcase" },
  { icon: "suitcase-rolling", label: "Suitcase rolling" },
  { icon: "suitcase-simple", label: "Suitcase simple" },
  { icon: "sun", label: "Sun" },
  { icon: "sun-dim", label: "Sun dim" },
  { icon: "sun-horizon", label: "Sun horizon" },
  { icon: "sunglasses", label: "Sunglasses" },
  { icon: "superset-of", label: "Superset of" },
  { icon: "superset-proper-of", label: "Superset proper of" },
  { icon: "swap", label: "Swap" },
  { icon: "swatches", label: "Swatches" },
  { icon: "swimming-pool", label: "Swimming pool" },
  { icon: "sword", label: "Sword" },
  { icon: "synagogue", label: "Synagogue" },
  { icon: "syringe", label: "Syringe" },
  { icon: "t-shirt", label: "T shirt" },
  { icon: "table", label: "Table" },
  { icon: "tabs", label: "Tabs" },
  { icon: "tag", label: "Tag" },
  { icon: "tag-chevron", label: "Tag chevron" },
  { icon: "tag-simple", label: "Tag simple" },
  { icon: "target", label: "Target" },
  { icon: "taxi", label: "Taxi" },
  { icon: "tea-bag", label: "Tea bag" },
  { icon: "telegram-logo", label: "Telegram logo" },
  { icon: "television", label: "Television" },
  { icon: "television-simple", label: "Television simple" },
  { icon: "tennis-ball", label: "Tennis ball" },
  { icon: "tent", label: "Tent" },
  { icon: "terminal", label: "Terminal" },
  { icon: "terminal-window", label: "Terminal window" },
  { icon: "test-tube", label: "Test tube" },
  { icon: "text-a-underline", label: "Text a underline" },
  { icon: "text-aa", label: "Text aa" },
  { icon: "text-align-center", label: "Text align center" },
  { icon: "text-align-justify", label: "Text align justify" },
  { icon: "text-align-left", label: "Text align left" },
  { icon: "text-align-right", label: "Text align right" },
  { icon: "text-b, text-bolder", label: "Text b, text bolder" },
  { icon: "text-columns", label: "Text columns" },
  { icon: "text-h", label: "Text h" },
  { icon: "text-h-five", label: "Text h five" },
  { icon: "text-h-four", label: "Text h four" },
  { icon: "text-h-one", label: "Text h one" },
  { icon: "text-h-six", label: "Text h six" },
  { icon: "text-h-three", label: "Text h three" },
  { icon: "text-h-two", label: "Text h two" },
  { icon: "text-indent", label: "Text indent" },
  { icon: "text-italic", label: "Text italic" },
  { icon: "text-outdent", label: "Text outdent" },
  { icon: "text-strikethrough", label: "Text strikethrough" },
  { icon: "text-subscript", label: "Text subscript" },
  { icon: "text-superscript", label: "Text superscript" },
  { icon: "text-t", label: "Text t" },
  { icon: "text-t-slash", label: "Text t slash" },
  { icon: "text-underline", label: "Text underline" },
  { icon: "textbox", label: "Textbox" },
  { icon: "thermometer", label: "Thermometer" },
  { icon: "thermometer-cold", label: "Thermometer cold" },
  { icon: "thermometer-hot", label: "Thermometer hot" },
  { icon: "thermometer-simple", label: "Thermometer simple" },
  { icon: "threads-logo", label: "Threads logo" },
  { icon: "three-d", label: "Three d" },
  { icon: "thumbs-down", label: "Thumbs down" },
  { icon: "thumbs-up", label: "Thumbs up" },
  { icon: "ticket", label: "Ticket" },
  { icon: "tidal-logo", label: "Tidal logo" },
  { icon: "tiktok-logo", label: "Tiktok logo" },
  { icon: "tilde", label: "Tilde" },
  { icon: "timer", label: "Timer" },
  { icon: "tip-jar", label: "Tip jar" },
  { icon: "tipi", label: "Tipi" },
  { icon: "tire", label: "Tire" },
  { icon: "toggle-left", label: "Toggle left" },
  { icon: "toggle-right", label: "Toggle right" },
  { icon: "toilet", label: "Toilet" },
  { icon: "toilet-paper", label: "Toilet paper" },
  { icon: "toolbox", label: "Toolbox" },
  { icon: "tooth", label: "Tooth" },
  { icon: "tornado", label: "Tornado" },
  { icon: "tote", label: "Tote" },
  { icon: "tote-simple", label: "Tote simple" },
  { icon: "towel", label: "Towel" },
  { icon: "tractor", label: "Tractor" },
  { icon: "trademark", label: "Trademark" },
  { icon: "trademark-registered", label: "Trademark registered" },
  { icon: "traffic-cone", label: "Traffic cone" },
  { icon: "traffic-sign", label: "Traffic sign" },
  { icon: "traffic-signal", label: "Traffic signal" },
  { icon: "train", label: "Train" },
  { icon: "train-regional", label: "Train regional" },
  { icon: "train-simple", label: "Train simple" },
  { icon: "tram", label: "Tram" },
  { icon: "translate", label: "Translate" },
  { icon: "trash", label: "Trash" },
  { icon: "trash-simple", label: "Trash simple" },
  { icon: "tray", label: "Tray" },
  { icon: "tray-arrow-down, archive-tray", label: "Tray arrow down, archive tray" },
  { icon: "tray-arrow-up", label: "Tray arrow up" },
  { icon: "treasure-chest", label: "Treasure chest" },
  { icon: "tree", label: "Tree" },
  { icon: "tree-evergreen", label: "Tree evergreen" },
  { icon: "tree-palm", label: "Tree palm" },
  { icon: "tree-structure", label: "Tree structure" },
  { icon: "tree-view", label: "Tree view" },
  { icon: "trend-down", label: "Trend down" },
  { icon: "trend-up", label: "Trend up" },
  { icon: "triangle", label: "Triangle" },
  { icon: "triangle-dashed", label: "Triangle dashed" },
  { icon: "trolley", label: "Trolley" },
  { icon: "trolley-suitcase", label: "Trolley suitcase" },
  { icon: "trophy", label: "Trophy" },
  { icon: "truck", label: "Truck" },
  { icon: "truck-trailer", label: "Truck trailer" },
  { icon: "tumblr-logo", label: "Tumblr logo" },
  { icon: "twitch-logo", label: "Twitch logo" },
  { icon: "twitter-logo", label: "Twitter logo" },
  { icon: "umbrella", label: "Umbrella" },
  { icon: "umbrella-simple", label: "Umbrella simple" },
  { icon: "union", label: "Union" },
  { icon: "unite", label: "Unite" },
  { icon: "unite-square", label: "Unite square" },
  { icon: "upload", label: "Upload" },
  { icon: "upload-simple", label: "Upload simple" },
  { icon: "usb", label: "Usb" },
  { icon: "user", label: "User" },
  { icon: "user-check", label: "User check" },
  { icon: "user-circle", label: "User circle" },
  { icon: "user-circle-check", label: "User circle check" },
  { icon: "user-circle-dashed", label: "User circle dashed" },
  { icon: "user-circle-gear", label: "User circle gear" },
  { icon: "user-circle-minus", label: "User circle minus" },
  { icon: "user-circle-plus", label: "User circle plus" },
  { icon: "user-focus", label: "User focus" },
  { icon: "user-gear", label: "User gear" },
  { icon: "user-list", label: "User list" },
  { icon: "user-minus", label: "User minus" },
  { icon: "user-plus", label: "User plus" },
  { icon: "user-rectangle", label: "User rectangle" },
  { icon: "user-sound", label: "User sound" },
  { icon: "user-square", label: "User square" },
  { icon: "user-switch", label: "User switch" },
  { icon: "users", label: "Users" },
  { icon: "users-four", label: "Users four" },
  { icon: "users-three", label: "Users three" },
  { icon: "van", label: "Van" },
  { icon: "vault", label: "Vault" },
  { icon: "vector-three", label: "Vector three" },
  { icon: "vector-two", label: "Vector two" },
  { icon: "vibrate", label: "Vibrate" },
  { icon: "video", label: "Video" },
  { icon: "video-camera", label: "Video camera" },
  { icon: "video-camera-slash", label: "Video camera slash" },
  { icon: "video-conference", label: "Video conference" },
  { icon: "vignette", label: "Vignette" },
  { icon: "vinyl-record", label: "Vinyl record" },
  { icon: "virtual-reality", label: "Virtual reality" },
  { icon: "virus", label: "Virus" },
  { icon: "visor", label: "Visor" },
  { icon: "voicemail", label: "Voicemail" },
  { icon: "volleyball", label: "Volleyball" },
  { icon: "wall", label: "Wall" },
  { icon: "wallet", label: "Wallet" },
  { icon: "warehouse", label: "Warehouse" },
  { icon: "warning", label: "Warning" },
  { icon: "warning-circle", label: "Warning circle" },
  { icon: "warning-diamond", label: "Warning diamond" },
  { icon: "warning-octagon", label: "Warning octagon" },
  { icon: "washing-machine", label: "Washing machine" },
  { icon: "watch", label: "Watch" },
  { icon: "wave-sawtooth", label: "Wave sawtooth" },
  { icon: "wave-sine", label: "Wave sine" },
  { icon: "wave-square", label: "Wave square" },
  { icon: "wave-triangle", label: "Wave triangle" },
  { icon: "waveform", label: "Waveform" },
  { icon: "waveform-slash", label: "Waveform slash" },
  { icon: "waves", label: "Waves" },
  { icon: "webcam", label: "Webcam" },
  { icon: "webcam-slash", label: "Webcam slash" },
  { icon: "webhooks-logo", label: "Webhooks logo" },
  { icon: "wechat-logo", label: "Wechat logo" },
  { icon: "whatsapp-logo", label: "Whatsapp logo" },
  { icon: "wheelchair", label: "Wheelchair" },
  { icon: "wheelchair-motion", label: "Wheelchair motion" },
  { icon: "wifi-high", label: "Wifi high" },
  { icon: "wifi-low", label: "Wifi low" },
  { icon: "wifi-medium", label: "Wifi medium" },
  { icon: "wifi-none", label: "Wifi none" },
  { icon: "wifi-slash", label: "Wifi slash" },
  { icon: "wifi-x", label: "Wifi x" },
  { icon: "wind", label: "Wind" },
  { icon: "windmill", label: "Windmill" },
  { icon: "windows-logo", label: "Windows logo" },
  { icon: "wine", label: "Wine" },
  { icon: "wrench", label: "Wrench" },
  { icon: "x", label: "X" },
  { icon: "x-circle", label: "X circle" },
  { icon: "x-logo", label: "X logo" },
  { icon: "x-square", label: "X square" },
  { icon: "yarn", label: "Yarn" },
  { icon: "yin-yang", label: "Yin yang" },
  { icon: "youtube-logo", label: "Youtube logo" }
];
